var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Invisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-invisible",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M10.056,14H9.939A10.639,10.639,0,0,1,.06,7.311.8.8,0,0,1,0,7a.991.991,0,0,1,.06-.329A10.64,10.64,0,0,1,9.931,0h.174a10.644,10.644,0,0,1,9.883,6.7.93.93,0,0,1,0,.3.812.812,0,0,1-.06.33A10.644,10.644,0,0,1,10.056,14ZM9.994,2A8.783,8.783,0,0,0,2.069,7a8.786,8.786,0,0,0,15.85,0A8.786,8.786,0,0,0,9.994,2Zm0,9a4,4,0,1,1,4-4A4,4,0,0,1,9.994,11Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,9.994,5Z",
    transform: "translate(2 5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Invisible);
export default __webpack_public_path__ + "static/media/icon-24-invisible.6b1acdc763bb4875b7c69874b51cf428.svg";
export { ForwardRef as ReactComponent };